import { DefecationNurseryDomainService } from './domain';
import { DefecationFactory } from './entity/defecationFactory';

import type { Logger } from '@/infra/logger';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { DefecationJson } from '@/types/domain/defecation/entities/defecationEntity';

/**
 * 排泄物アプリケーションサービス(施設)
 */
export class DefecationNurseryApplicationService {
  private service!: DefecationNurseryDomainService;

  private defecationFactory = new DefecationFactory();

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   * @param logger logger
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
    logger: Logger,
  ) {
    this.service = new DefecationNurseryDomainService(logger);
    this.service.inject(wagakoNurseryApi);
  }

  /**
   * sendNurseryDefecation
   * @param input 入力
   */
  async sendNurseryDefecation(
    input: DefecationJson,
  ) {
    const entity = this.defecationFactory.createFromJson(input);
    await this.service.sendNurseryDefecation(entity);
  }

  /**
   * removeNurseryDefecation
   * @param input 入力
   */
  async removeNurseryDefecation(
    input: DefecationJson,
  ) {
    const entity = this.defecationFactory.createFromJson(input);
    await this.service.removeNurseryDefecation(entity);
  }
}
